/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, Tooltip, useColorModeValue } from "@chakra-ui/react";
import { useTranslation } from 'i18n/TranslationProvider';

import { useGetUserRole } from 'domains/user/hooks/useGetUserRole';
import { useListing } from 'contexts/ListingContext';

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = useColorModeValue("gray.700", "white");
  let inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  let activeIcon = useColorModeValue("brand.500", "white");
  let textColor = useColorModeValue("secondaryGray.500", "white");
  let brandColor = useColorModeValue("brand.500", "brand.400");

  const { routes, isCompact = false, isCollapsed = false, onLinkClick } = props;
  const { t } = useTranslation();
  const { role } = useGetUserRole();
  const { resetListing } = useListing();

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeFullPath) => {
    const current = location.pathname.toLowerCase();
    const path = routeFullPath.toLowerCase();
    if (path.includes('/:')) {
      const base = path.split('/:')[0];
      return current.startsWith(base + '/');
    }
    return current === path;
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.sidebar === false) return null;
      if (route.roles && !route.roles.includes(role)) return null;

      if (route.category) {
        return (
          <>
            <Text
              fontSize={"md"}
              color={activeColor}
              fontWeight='bold'
              mx='auto'
              ps={{
                sm: "10px",
                xl: "16px",
              }}
              pt='18px'
              pb='12px'
              key={index}>
              {t(route.name)}
            </Text>
            {createLinks(route.items)}
          </>
        );
      } else if (
        route.layout === "/admin" ||
        route.layout === "/auth" ||
        route.layout === "/rtl" ||
        route.layout === "/"
      ) {
        const routePath = route.layout === '/' ? route.path : route.layout + route.path;
        const isActive = activeRoute(routePath.toLowerCase());
        const spacing = isCollapsed ? 0 : isCompact ? "14px" : "20px";
        const paddingY = isCollapsed ? '8px' : isCompact ? '8px' : '10px';
        const fontSize = isCompact ? 'sm' : 'md';
  const activeIconBg = useColorModeValue("gray.100", "gray.700");
  // ... inside createLinks
        const link = (
          <HStack
            spacing={spacing}
            py={paddingY}
            ps={isCollapsed ? '0px' : '10px'}
            bg={isActive ? activeIconBg : "transparent"}
            borderRadius="md"
          >
            <Flex
              w='100%'
              alignItems='center'
              justifyContent={isCollapsed ? 'center' : 'flex-start'}
            >
              <Box
                color={isActive ? brandColor : textColor}
                me={isCollapsed ? 0 : '12px'}
                fontSize="xl"
              >
                {route.icon}
              </Box>
              {!isCollapsed && (
                <Text
                  me="auto"
                  color={isActive ? brandColor : textColor}
                  fontWeight={isActive ? "bold" : "normal"}
                  fontSize={fontSize}
                >
                  {t(route.name)}
                </Text>
              )}
            </Flex>
          </HStack>
        );
        const handleClick = () => {
          if (routePath === '/create-listing') {
            resetListing();
          }
          if (typeof onLinkClick === 'function') {
            onLinkClick();
          }
        };
        return (
          <NavLink
            key={index}
            to={routePath}
            onClick={handleClick}
          >
            {route.icon ? (
              <Tooltip
                label={t(route.name)}
                placement="right"
                openDelay={100}
                isDisabled={!isCollapsed}
                hasArrow
              >
                <Box>{link}</Box>
              </Tooltip>
            ) : (
              <Box>{link}</Box>
            )}
          </NavLink>
        );
      }
    });
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
